export default "__VITE_ASSET__thIVIHCK__"